import styled from 'styled-components';
import { Button } from 'antd';

export const Wrapper = styled.div`
  padding-top: 200px;
  text-align: center;
`;
